import type { Motif } from "@/routes/innovation-days-demo/types";

interface MotifsContentProps {
  motifs: Motif[];
}

export function MotifsContent({ motifs }: MotifsContentProps) {
  return (
    <div className="space-y-4">
      {motifs.map((m) => (
        <div key={m.name} className="relative pl-4">
          {/* Left accent bar */}
          <div
            className="absolute left-0 top-0 bottom-0 w-1 rounded-full"
            style={{ background: "#6366F1" }}
          />

          <div className="space-y-1.5">
            {/* Motif name */}
            <h4
              className="text-[15px] leading-[20px] font-semibold"
              style={{ color: "#0F172A" }}
            >
              {m.name}
            </h4>

            {/* Motif description */}
            <p
              className="text-[14px] leading-[20px]"
              style={{ color: "#64748B" }}
            >
              {m.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
